import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  Branch,
  CarBrand,
  CarModel,
  Color,
  Drivetrain,
  EngineCapacity,
  EngineTransmissionConditions,
  EngineType,
  LightConditions,
  RegexDef,
  SaloonConditions,
  ScratchConditions,
  SteeringType,
  TransmissionType,
  ValuateType,
  VehicleCondition,
  VehicleSource,
  VinSource,
  WarningLightConditions,
  WindowConditions,
} from '../../interfaces';

export interface GeneralState {
  branches: Branch[];
  carBrands: CarBrand[];
  carModels: CarModel[];
  drivetrain: Drivetrain[];
  engineCapacities: EngineCapacity[];
  engineTypes: EngineType[];
  exteriorColors: Color[];
  interiorColors: Color[];
  regexes: RegexDef[];
  steeringTypes: SteeringType[];
  transmissionTypes: TransmissionType[];
  valuateTypes: ValuateType[];
  vehicleConditions: VehicleCondition[];
  vehicleSources: VehicleSource[];
  vinSources: VinSource[];
  yearsFrom2000: string[];
  engineTransmissionConditions: EngineTransmissionConditions[];
  lightConditions: LightConditions[];
  windowConditions: WindowConditions[];
  scratchConditions: ScratchConditions[];
  saloonConditions: SaloonConditions[];
  warningLightConditions: WarningLightConditions[];

  forgot?: {
    username?: string;
    otp?: string;

    accessToken?: string;
    sessionState?: string;
    userId?: string;
  };
}

const initialState: GeneralState = {
  branches: [],
  carBrands: [],
  carModels: [],
  drivetrain: [],
  engineCapacities: [],
  engineTypes: [],
  exteriorColors: [],
  interiorColors: [],
  regexes: [],
  steeringTypes: [],
  transmissionTypes: [],
  valuateTypes: [],
  vehicleConditions: [],
  vehicleSources: [],
  vinSources: [],
  yearsFrom2000: [],
  engineTransmissionConditions: [],
  lightConditions: [],
  windowConditions: [],
  scratchConditions: [],
  saloonConditions: [],
  warningLightConditions: [],

  forgot: {
    username: undefined,
    otp: undefined,

    accessToken: undefined,
    sessionState: undefined,
    userId: undefined,
  },
};

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setInit: (state, action: PayloadAction<GeneralState>) => {
      state.branches = action.payload.branches;
      state.carBrands = action.payload.carBrands;
      state.carModels = action.payload.carModels;
      state.drivetrain = action.payload.drivetrain;
      state.engineCapacities = (action?.payload?.engineCapacities || []).map((item) => ({
        ...item,
        value: undefined,
      }));
      state.engineTypes = action.payload.engineTypes;
      state.exteriorColors = action.payload.exteriorColors;
      state.interiorColors = action.payload.interiorColors;
      state.regexes = action.payload.regexes;
      state.steeringTypes = action.payload.steeringTypes;
      state.transmissionTypes = action.payload.transmissionTypes;
      state.valuateTypes = action.payload.valuateTypes;
      state.vehicleConditions = action.payload.vehicleConditions;
      state.vehicleSources = action.payload.vehicleSources;
      state.vinSources = action.payload.vinSources;
      state.yearsFrom2000 = action.payload.yearsFrom2000;
    },

    setForgotPassword: (state, action: PayloadAction<any>) => {
      // state..code = action?.payload.code;

      console.log('action?.payload :', action?.payload);
      state.forgot = action?.payload;
      // state.username = action?.payload.username;
    },
  },
});

export const { setInit, setForgotPassword } = generalSlice.actions;

export default generalSlice.reducer;
